import { faCircle } from '@fortawesome/pro-light-svg-icons/faCircle';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InvoicePromocode } from '@spike/invoice-model';
import clsx from 'clsx';
import { FunctionComponent, MouseEvent } from 'react';
import styles from './PromocodeItem.module.scss';

interface PromocodeItemProps {
    promocode: InvoicePromocode;
    selected: boolean;
    disabled?: boolean;
    className?: string;
    onClick?: () => void;
}
export const PromocodeItem: FunctionComponent<PromocodeItemProps> = props => {
    const clickHandler = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();

        if (!props.disabled) {
            props.onClick?.();
        }
    };

    return (
        <div
            className={clsx(styles.container, props.className)}
            onClick={clickHandler}
        >
            <div className={styles.left}>
                <span className={styles.name}>{props.promocode.name}</span>
                <span className={styles.description}>{props.promocode.description}</span>
            </div>
            <div className={styles.right}>
                <FontAwesomeIcon
                    icon={props.selected ? faCheckCircle : faCircle}
                    className={clsx({ [styles.icon]: !props.selected, [styles.selectedIcon]: props.selected })}
                />
            </div>
        </div>
    );
};

export default PromocodeItem;
